import { useQuery } from 'react-query';
import { QueryKeys } from '../QueryKey';
import axiosInstance from '../axiosConfig';

export function useGetReviewsByCompanyProfId(companyProfId: string) {
    const getReviewsByCompanyProfId = async (companyProfId: string) => {
        const response = await axiosInstance.get(
            `/api/company-reviews-requests/reviews/${companyProfId}`
        );
        const data = await response.data;
        return data;
    };
    return useQuery(QueryKeys.RetrieveCompanyReviews, () =>
        getReviewsByCompanyProfId(companyProfId),
    );
}
